import { MenuOpenOutlined } from "@mui/icons-material"
import { IconButton, Typography } from "@mui/material"

import AccordionGroup from "@components/accordion_group"
import LeftDrawer from "@components/persist_drawer"
import SectionBar from "@components/section_bar"
import { PRIMARY } from "@constants/colors"
import { useAccountPageContext } from "@contexts/account"

export default function AccountPageLeftDrawer() {
  const {
    isLeftDrawerOpen,
    toggleIsLeftDrawerOpen,
    navigationColumns,
    navigationValue,
    handleClickNavigationRow
  } = useAccountPageContext()

  return (
    <LeftDrawer
      isOpen={!!isLeftDrawerOpen}
      header={<LeftDrawerHeader setClose={toggleIsLeftDrawerOpen} />}
      sx={{
        borderRight: 1,
        borderColor: "divider",
        width: "16rem",
        minWidth: "16rem",
        maxWidth: "16rem"
      }}
    >
      <AccordionGroup
        accordionList={navigationColumns}
        onClick={handleClickNavigationRow}
        selectedValue={navigationValue}
      />
    </LeftDrawer>
  )
}

function LeftDrawerHeader({ setClose }: { setClose?: () => void }) {
  const { translate } = useAccountPageContext()
  return (
    <SectionBar
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        p: 1
      }}
    >
      <Typography p={1} variant="h6">
        {translate("account_tooltip")}
      </Typography>
      <IconButton
        disableRipple
        sx={{
          ":hover": {
            color: PRIMARY
          }
        }}
        onClick={setClose}
      >
        <MenuOpenOutlined />
      </IconButton>
    </SectionBar>
  )
}
